import Auth from 'live/services/authorization'

export function canTriggerSync(): boolean {
    return Auth.Permission.isAdmin || Auth.Permission.DVD_SYNC_ADMIN
}

export function canViewDvDData(): boolean {
    return Auth.Permission.isAdmin || Auth.Permission.DVD_DATA_VIEWERS
}

export function canEditDvDData(): boolean {
    return Auth.Permission.isAdmin || Auth.Permission.DVD_EDITOR
}

export function canViewWellPlanData(): boolean {
    return Auth.Permission.isAdmin || Auth.Permission.WELL_PLAN_DATA_VIEWERS
}

export function canEditWellPlanData(): boolean {
    return Auth.Permission.isAdmin || Auth.Permission.WELL_PLAN_EDITOR
}
